import { render } from "./Power_SolarBracket.vue?vue&type=template&id=7c31a5c8"
import script from "./Power_SolarBracket.vue?vue&type=script&lang=js"
export * from "./Power_SolarBracket.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__